function About() {
  return <div className="about">Under constriction</div>;
}

export default About;
